export default __webpack_public_path__ + "static/media/tuto.898be460.webp";